import { Container, Link, Text } from "@simplybusiness/mobius";

type ExtraUKTextProps = {
  phoneNumber?: string;
};

export function ExtraUKText({ phoneNumber }: ExtraUKTextProps) {
  return (
    <Container>
      <Text
        className="mobius-quote-headline__text mobius-quote-headline__text--variant-without-qdp-drawer"
        style={{ color: "var(--color-text-lead)" }}
      >
        You can make changes to the covers you selected here: Can&apos;t find
        the cover you&apos;re looking for?
        <br />
        Give us a call on{" "}
        <Link
          aria-label="Contact telephone number"
          data-testid="phone-number-link"
          href={`tel:${phoneNumber}`}
          style={{ color: "var(--color-text-lead)" }}
        >
          {phoneNumber}
        </Link>{" "}
        and one of our team could help.
      </Text>
    </Container>
  );
}
